import { View } from '@shared/components/View';
import { MBButton } from '@shared/components/button';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useDraggableContext } from './DraggableContext';

interface Props {
  showMore(): void;
  hasMore: boolean;
  isMoreLoading: boolean;
}

export function CardListFooter({ showMore, hasMore, isMoreLoading }: Props) {
  const { isDragging } = useDraggableContext();
  return (
    <View paddingHorizontal={2} paddingVertical={1}>
      {hasMore && (
        <MBButton
          title={i18n('card.list.showMore')}
          size="small"
          theme="transparent"
          bold={false}
          loading={isMoreLoading}
          borderColor={Colors.v2.gray10}
          onPress={showMore}
          style={{ alignSelf: 'flex-start', opacity: isDragging ? 0.1 : 1 }}
        />
      )}
    </View>
  );
}
